export default __webpack_public_path__ + "static/media/hanzo.12f07134.webp";